import React, { useContext, useEffect, useRef, useState } from "react";
import Card from "../../../Base/Components/Card/Card";
import { Button } from "primereact/button";
import { getListQr } from "../../../API/RRHH/Marcaje/QRMarcasRequest";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import QRMarcajeCrud from "./QRMarcajeCrud";
import ModalQRMarcaje from "./ModalQRMarcaje";
import ListadoDetallesQR from "./ListadoDetallesQR";
import { toastShow } from "../../../Base/Services/ToastService";
import { Toast } from "primereact/toast";
const QRMarcajeScreen = () => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [visible, setVisible] = useState(false);

  const [showEtiqueta, setShowEtiqueta] = useState(false);
  const [etiquetaQR, setEtiquetaQR] = useState(true);
  const [openDialogDetalle, setOpenDialogDetalle] = useState(false);
  const [idMarcajeQR, setIdMarcajeQR] = useState(null)

  const getInfo = async () => {
    setLoading(true);
    const listQR = await getListQr();
    setData(listQR);
    setLoading(false);
  };

  const openDialogDet = (IdQR) =>{
    setOpenDialogDetalle(true);
    setIdMarcajeQR(IdQR)
  }

  const onHideDet = () => {
    setOpenDialogDetalle(false);
    setIdMarcajeQR(null)
  }

  const columnOrdenes = [
    {
      field: "IdQR",
      header: "ID",
      className: "Xsmall",
      alignFrozen: "left",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
    },
    {
      // FECHA CREADO
      field: "DateCreate",
      header: "Fecha Creado",
      className: "small",
      alignFrozen: "left",
      frozen: "frozen",
      Format: "Date",
    },
    {
      // ESTADO
      field: "Estado",
      header: "Estado",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      // FECHA CREADO
      field: "Descripcion",
      header: "Descripción",
      className: "large",
      flex:1,
    },
    // {
    //   // Secciones
    //   field: "NombreSecciones",
    //   header: "Secciones",
    //   className: "small",
    //   flex:1,
    //   minWidth:200
    // },
    {
      field: "Universal",
      header: "Universal",
      className: "Xsmall",
      Format:'Checkbox'
    },
    {
      field: "idUserCreate",
      header: "Id Usuario Creo",
      className: "Xsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "UserName",
      header: "Usuario Creo",
      className: "large",
      hidden: userAuth.IdRol === 1,
    },
    {
      frozen: true,
      alignFrozen: "right",
      field: "IdMenu",
      className: 'Xsmall',
      textAlign: 'center',
      header: "",
      Format: "Botones",
      filter: false,
      Botones: [
        {
          icon: "pi pi-align-justify",
          tooltip: "Detalles",
          onClick: (rowData) => {
            openDialogDet(rowData.IdQR)
          },
          tooltipOptions: {
            position: "left",
          },
        },
        {
          icon: "pi pi-qrcode",
          tooltip: "QR",
          onClick: (rowData) => {
            if(rowData?.IdQR){
              if(selected.length <= 0){
                setSelected([rowData]);
              }                      
              if(selected.length > 4){
                toastShow(toast, "warn", "Advertencia", "Solo se permite seleccionar 4 QR");
                // return; 
              }
              setTimeout(() => {
                setShowEtiqueta(true)
                setEtiquetaQR(true)
              }, 500);
            }
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ]
    }
  ];

  const table = {
    Columns: columnOrdenes,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    // showModal: e => showModal(e),
  };

  useEffect(() => {
    getInfo();
    window.document.title = 'PPF • QR Marcaje';
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>QR Marcaje</h3>
            <Button icon="pi pi-sync" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => setVisible(true)}
            />
          </div>
        }
        contenido={
          <div className="pt-2">
            <div className="pt-4" style={{ height: "83vh" }}>
              <AgGrid table={table} />
            </div>
          </div>
        }
      />


      <QRMarcajeCrud
        visible={visible}
        setVisible={setVisible}
        getinfo={getInfo}/>

      {showEtiqueta && (
        <ModalQRMarcaje
          showEtiqueta={showEtiqueta}
          setShowEtiqueta={setShowEtiqueta}
          selected={selected.length > 4 ? selected.slice(0,4).sort((a, b) => a?.IdQR > b?.IdQR ? 1 : -1) : selected}
          setSelected={setSelected}
          getInfo={getInfo}
        />
      )}

      <ListadoDetallesQR openDialogDetalle={openDialogDetalle} onHideDialogDetalle={onHideDet} idMarcajeQR={idMarcajeQR}/>

    </div>
  );
};

export default QRMarcajeScreen;
